import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';

const LEGAL_TEXT = `FIFTY TWO IN THE LOU
Terms of Service, Privacy Policy & Legal Notices
Effective Date: June 1, 2026 | Last Updated: June 1, 2026

A product of Fifty Two Weeks™
JW Multimedia Productions LLC (JWMP LLC)
10 Norwood Court, Edwardsville, Illinois 62025
www.fiftytwointhelou.com | www.52inthelou.com

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
TERMS OF SERVICE
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

1. ACCEPTANCE OF TERMS

By creating an account or using the Fifty Two in the Lou application ("Service"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Service. These Terms constitute a legally binding agreement between you and JW Multimedia Productions LLC ("JWMP LLC," "we," "us," or "our"), an Illinois limited liability company.

2. DESCRIPTION OF SERVICE

Fifty Two in the Lou is a web-based application providing users with a curated list of places to visit in the St. Louis metropolitan area and Illinois Metro East region. Users may track visited locations, schedule future visits, add custom places, and personalize their experience. The Service is currently in Alpha prototype stage (FiftyTwo.Alpha.Prototype.1). Features and availability may change without notice.

3. ELIGIBILITY

You must be at least 13 years of age to use the Service. If you are under 18, you must have the consent of a parent or legal guardian.

4. USER ACCOUNTS

4.1 Registration: You agree to provide accurate, complete information and keep it current.

4.2 Account Security: You are responsible for maintaining the confidentiality of your credentials. Notify us immediately of any unauthorized use of your account.

4.3 Termination: We reserve the right to suspend or terminate your account at any time for conduct that violates these Terms or is harmful to other users or the Service.

5. USER CONTENT

5.1 Your Content: You retain ownership of custom places and content you submit ("User Content").

5.2 License Grant: By submitting User Content, you grant JWMP LLC a non-exclusive, royalty-free, worldwide license to use, store, display, and distribute your User Content solely for the purpose of operating the Service.

5.3 Content Standards: You agree not to submit User Content that is unlawful, defamatory, obscene, offensive, or infringing on third-party rights. We reserve the right to remove any User Content at our discretion.

6. PROHIBITED CONDUCT

You agree not to:
- Use the Service for any unlawful purpose
- Attempt to gain unauthorized access to any portion of the Service
- Reverse engineer, decompile, or disassemble any portion of the Service
- Use automated tools (bots, scrapers) to access the Service
- Impersonate any person or entity
- Transmit viruses, malware, or other harmful code

7. INTELLECTUAL PROPERTY

The Service, including all software, design, text, graphics, logos, and content created by JWMP LLC, is owned by JW Multimedia Productions LLC and protected by United States copyright and trademark laws. The marks "Fifty Two in the Lou™," "52 in the Lou™," "Fifty Two Weeks™," and "52 Weeks™" are trademarks of JW Multimedia Productions LLC.

You are granted a limited, non-exclusive, non-transferable, revocable license to access and use the Service for personal, non-commercial purposes only.

8. THIRD-PARTY SERVICES

The Service integrates with Google Maps, Google Calendar, and Pexels. Your use of these services is governed by their respective terms and privacy policies. We are not responsible for third-party availability, accuracy, or content.

9. DISCLAIMER OF WARRANTIES

THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.

10. LIMITATION OF LIABILITY

TO THE FULLEST EXTENT PERMITTED BY LAW, JWMP LLC SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE SERVICE. OUR TOTAL LIABILITY SHALL NOT EXCEED $100.00.

11. INDEMNIFICATION

You agree to indemnify and hold harmless JWMP LLC, its members, officers, and agents from any claims, liabilities, damages, or expenses arising from your use of the Service or violation of these Terms.

12. GOVERNING LAW

These Terms are governed by the laws of the State of Illinois. Any disputes shall be resolved by binding arbitration in Madison County, Illinois. You waive any right to participate in class action proceedings.

13. CHANGES TO TERMS

We may update these Terms at any time. Continued use of the Service after changes constitutes acceptance of the updated Terms.

14. CONTACT

JW Multimedia Productions LLC
10 Norwood Court, Edwardsville, Illinois 62025
jwhite83193@gmail.com | www.fiftytwointhelou.com

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
PRIVACY POLICY
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

1. INFORMATION WE COLLECT

We collect only what you provide:
- First name, last name, email address, username
- Password (stored as a secure BCrypt hash — never in plain text)
- Phone number (optional)
- Notification preference
- Custom places you manually add
- Places you mark as visited and scheduled visit dates

2. WHAT WE DO NOT COLLECT

- Payment information
- GPS or real-time location data
- Health or biometric data
- Data from your contacts, camera, or microphone
- Advertising or cross-site tracking data

3. HOW WE USE YOUR INFORMATION

- To create and manage your account
- To save and sync your checklist progress
- To send password reset and username recovery emails
- To improve and operate the Service
- To detect and prevent unauthorized activity

4. HOW WE SHARE YOUR INFORMATION

We do not sell, trade, or rent your personal information. Service providers:
- Railway (railway.app) — hosting and database
- SendGrid — transactional email delivery
- Pexels — photo API (place names only, no personal data)

5. DATA SECURITY

- Passwords are BCrypt-encoded and never stored in plain text
- All data in transit is encrypted via HTTPS
- JWT authentication with 7-day token expiry
- Rate limiting on login endpoints

6. GUEST MODE

Guest Mode collects no personal information. Visited places are stored only in your browser session and deleted when you close your browser.

7. YOUR RIGHTS

You may update your profile at any time in the app. To request access to or deletion of your data, contact jwhite83193@gmail.com. We respond within 30 days. California residents have rights under CCPA. Illinois residents are protected under PIPA. We do not sell personal information.

8. CHILDREN'S PRIVACY

The Service is not directed to children under 13. We do not knowingly collect data from children under 13.

Full Privacy Policy: www.fiftytwointhelou.com/privacy

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
DMCA & COPYRIGHT
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

JWMP LLC respects intellectual property rights. To report infringement:

Joshua White — JW Multimedia Productions LLC
10 Norwood Court, Edwardsville, Illinois 62025
jwhite83193@gmail.com
Subject: "DMCA Notice — Fifty Two in the Lou"

Full DMCA Policy: www.fiftytwointhelou.com/dmca

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

© 2026 JW Multimedia Productions LLC. All rights reserved.
Fifty Two in the Lou™ and Fifty Two Weeks™ are trademarks of
JW Multimedia Productions LLC.

FiftyTwo.Alpha.Prototype.1`;

const LegalModal = ({ onAccept }) => {
  const { theme } = useTheme();
  const [read, setRead] = useState(false);

  const handleDownload = () => {
    const blob = new Blob([LEGAL_TEXT], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'FiftyTwoInTheLou_Legal.txt';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.85)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000, padding: '20px'
    }}>
      <div style={{
        backgroundColor: theme.cardBackground,
        borderRadius: '12px',
        padding: '24px',
        width: '100%',
        maxWidth: '480px',
        maxHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      }}>
        <div style={{ textAlign: 'center' }}>
          <h2 style={{ color: theme.buttonPrimary, margin: '0 0 4px 0', fontSize: '1.1rem', fontWeight: '700' }}>
            Fifty Two in the Lou
          </h2>
          <p style={{ color: theme.subText, margin: 0, fontSize: '0.75rem' }}>
            Terms of Service · Privacy Policy · Legal Notices
          </p>
        </div>
        <div style={{
          overflowY: 'auto', flex: 1,
          backgroundColor: theme.background,
          padding: '12px', borderRadius: '8px',
          fontSize: '0.78rem', color: theme.text,
          whiteSpace: 'pre-wrap', lineHeight: '1.65',
          fontFamily: 'monospace'
        }}>
          {LEGAL_TEXT}
        </div>
        <div style={{ fontSize: '0.75rem', color: theme.subText, textAlign: 'center', lineHeight: '1.6' }}>
          Full documents at{' '}
          <a href="https://www.fiftytwointhelou.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: theme.buttonPrimary }}>Privacy Policy</a>
          {' · '}
          <a href="https://www.fiftytwointhelou.com/dmca" target="_blank" rel="noopener noreferrer" style={{ color: theme.buttonPrimary }}>DMCA Policy</a>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input type="checkbox" id="acceptTerms" checked={read} onChange={(e) => setRead(e.target.checked)} style={{ cursor: 'pointer', width: '16px', height: '16px' }} />
          <label htmlFor="acceptTerms" style={{ color: theme.text, fontSize: '0.85rem', cursor: 'pointer', lineHeight: '1.4' }}>
            I have read and agree to the Terms of Service and Privacy Policy
          </label>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={handleDownload} style={{
            flex: 1, padding: '12px', borderRadius: '8px',
            border: `2px solid ${theme.buttonPrimary}`,
            backgroundColor: 'transparent', color: theme.buttonPrimary,
            fontWeight: '700', cursor: 'pointer', fontSize: '0.9rem'
          }}>
            Download .txt
          </button>
          <button onClick={onAccept} disabled={!read} style={{
            flex: 1, padding: '12px', borderRadius: '8px', border: 'none',
            backgroundColor: read ? theme.buttonPrimary : theme.border,
            color: read ? theme.buttonText : theme.subText,
            fontWeight: '700', cursor: read ? 'pointer' : 'not-allowed',
            fontSize: '0.9rem', transition: 'background-color 0.2s ease'
          }}>
            Accept & Continue
          </button>
        </div>
        <p style={{ color: theme.subText, fontSize: '0.7rem', textAlign: 'center', margin: 0, lineHeight: '1.4' }}>
          © 2026 JW Multimedia Productions LLC. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default LegalModal;